import React from "react";
import moment from "moment";
import { ShipmentStatus, QuoteStatus } from "@/utils/enum";
import QuoteAlert from "./QuoteAlert";

export const renderQuoteStatus = (quote, shipmentStatus) => {
  if (!quote || !shipmentStatus) {
    return [null, null];
  }

  if (quote.status === QuoteStatus.None) {
    return [<QuoteAlert key="missing" alertType="missing" />, "missing"];
  }

  if (quote.expired) {
    return [<QuoteAlert key="expired" alertType="expired" />, "expired"];
  }

  // client side 2 week expiration check
  // doing this only when the shipment is confirmed status. after posting, quotes don't expire
  if (shipmentStatus === ShipmentStatus.Completed && quote.resolvedAt) {
    const checkResolvedAt = moment(quote.resolvedAt).add(2, "weeks");
    const currentTime = moment();
    if (currentTime.diff(checkResolvedAt) > 0) {
      return [<QuoteAlert key="expired" alertType="expired" />, "expired"];
    }
  }

  if (quote.status === QuoteStatus.Pending) {
    return [<QuoteAlert key="pending" alertType="pending" />, "pending"];
  }

  return [<div key="completed" />, "completed"];
};
